<template>
  <agreement-pollbox
    :title="'섭취하실 분의 성별을 선택하여주세요.'"
  >
    <div class="check_gender">
      <ul>
        <li
          v-for="(content, index) in contents"
          :key="index"
        >
          <input
            :id="`gender${index}`"
            v-model="selectedCode"
            type="radio"
            name="check_gender"
            :value="content.code"
          >
          <label :for="`gender${index}`">
            <div class="rdo_img">{{ content.name }}</div>
          </label>
        </li>
      </ul>
    </div>
  </agreement-pollbox>
</template>
<script>
import AgreementPollbox from './AgreementPollbox.vue';

export default {
  name: 'AgreementPollboxSex',
  components: {
    AgreementPollbox,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedCode: this.value,
      contents: [
        {
          name: '여성',
          code: '여성',
        },
        {
          name: '남성',
          code: '남성',
        },
      ],
    };
  },
  watch: {
    selectedCode(newVal) {
      this.$emit('input', newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/agreement/main/partial/AgreementPollboxSex.vue